import {Component, inject, OnInit} from '@angular/core';
import {MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {ErrorLogService} from '../../services/error-log-service';
import {GithubIssueService} from '../../services/github-issue.service';
import {GithubIssueDTO} from '../../dto/github-issue';
import {version} from '../../../../../package.json';
import {environment} from '../../../../environments/environment';
import {CloseableDialogComponent} from "../closeable-dialog/closeable-dialog.component";

@Component({
  selector: 'app-github-issue-dialog',
  imports: [
    MatListModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogActions,
    MatDialogContent,
    CloseableDialogComponent
  ],
  templateUrl: './github-issue-dialog.component.html',
  styleUrl: './github-issue-dialog.component.scss'
})
export class GithubIssueDialogComponent implements OnInit {
  private readonly dialogRef: MatDialogRef<GithubIssueDialogComponent> = inject(MatDialogRef);
  private readonly errorLogService: ErrorLogService = inject(ErrorLogService);
  private readonly service: GithubIssueService = inject(GithubIssueService);
  private readonly fb: FormBuilder = inject(FormBuilder);

  public version: string = version;

  public stage = environment.stage;

  issueForm: FormGroup = this.fb.group({
    title: ['', [Validators.required, Validators.minLength(5)]],
    body: ['', [Validators.required, Validators.minLength(10)]]
  });
  lastErrors: any[] = [];

  ngOnInit() {
    this.lastErrors = this.errorLogService.getLastErrors(3);
  }

  cancel() {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.issueForm.valid) {
      const formValue = this.issueForm.value as GithubIssueDTO;
      if (this.lastErrors && this.lastErrors.length > 0) {
        formValue.body += '\n\n\n\n\n Last Errors:\n';
        formValue.body += this.lastErrors.map(e => e).join('\n\n');
      }
      this.service.createIssue(formValue).subscribe(() => {
        this.dialogRef.close();
      });
    }
  }
}
